import styled from 'styled-components'
import { MdClose } from 'react-icons/md'

export const ClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 10;
  color: ${({ theme }) => theme.colors.white};
  /* @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 36px;
    height: 36px;
    top: 60px;
  } ; */
`

export const SuccessWrapper = styled.div`
  width: 450px;
  padding: 30px 30px;
`

export const SuccessModalContainer = styled.div`
  width: 100vw;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    height: 70%;
  }
`

export const SuccessModalBackground = styled.div`
  width: 500px;
  background: rgba(105, 121, 248, 1);
  z-index: 9000000000000000000;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  color: #ffff;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    border-radius: 40px 40px 0px 0px;

    /* height: 70%; */
  }
`

export const SuccessContentWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .success_content {
    height: 200px;
    margin-bottom: 30px;
  }

  .success_svg {
    margin-bottom: 30px;
  }

  .success_text {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .awesome {
    font-size: ${({ theme }) => theme.fontSize.xxl};
    font-family: ${({ theme }) => theme.fontSize.inter};
    margin: 0;
    line-height: 41px;
    font-weight: 400;
  }

  .process_text {
    font-weight: 400;
    font-size: 13px;
    line-height: 28px;
    font-family: ${({ theme }) => theme.fontSize.inter};
    font-size: ${({ theme }) => theme.fontSize.x4};
  }

  .btn_wrapper {
    width: 80%;
  }
`
